import { createSlice } from '@reduxjs/toolkit';

const findPasswordSlice = createSlice({
  name: 'findPassword',
  initialState: {
    userInfo: {},
    auth: false,
    financial: true,
    updatePwd: false,
    updatePwdKms: false,
    blockOtpRequest: false,
    isCheckPinCode: undefined,
    error: {
      fnmInput: '',
      otpMobile: '',
    },
    incorrectOTPcount: 0,
    incorrectPINcount: 0,
    pinSendInfo: undefined,
    pushYn: false,
    userToken: undefined,
    push: {
      pushServer: [],
      mobileUserYn: false,
    },
    isSuccessPushAuth: false,
    isSuccessSkip: false,
  },
  reducers: {
    setRequestOtpState: (state, { payload }) => {
      state.blockOtpRequest = !payload;
    },
    getAuthenticateFnm: () => {},
    getAuthenticateFnmSuccess: (state, { payload }) => {
      state.userInfo = payload;
      // state.userInfo.kmsRegStatsCd = 'RC';
      state.mphonNo = payload.mphonNo ? payload.mphonNo.split(',')[0] : null;
    },
    setAuthenticateFnmFail: (state, { payload: error }) => {
      state.error = {};
      if (error?.errorCode === 'EM606') state.error.userId = 'MB_M_FINDPWD_FNM_ID_NOT_MATCH';
      else state.error.userId = error?.errorCode;
    },
    initAuthenticateFnmFail: state => {
      state.error = {};
    },
    getAuthenticateCallPhone: () => {},
    getAuthenticateCallPhoneSuccess: () => {},
    getAuthenticateCallPhoneFail: () => {},
    getAuthenticateExternalMail: () => {},
    getAuthenticateExternalMailSuccess: () => {},
    getAuthenticateExternalMailFail: () => {},
    getAuthenticateAuthNum: (state, { payload }) => {
      state.authnum = payload.authnum;
    },
    getAuthenticateAuthNumSuccess: (state, { payload }) => {
      state.auth = true;
      state.financial = payload.financial;
    },
    setAuthenticateAuthNumFail: (state, { payload }) => {
      state.error.otpMobile = payload;
      state.incorrectOTPcount += 1;
    },
    modifyAuthenticatePassword: () => {},
    modifyAuthenticatePasswordSuccess: (state, { payload }) => {
      state.updatePwd = payload;
    },
    resetIncorrectOTPcount: state => {
      state.incorrectOTPcount = 0;
      state.error.otpMobile = '';
    },
    getCheckPinCode: state => {
      state.isCheckPinCode = false;
    },
    getCheckPinCodeSuccess: state => {
      state.isCheckPinCode = true;
    },
    getCheckPinCodeFail: (state, { payload }) => {
      if (payload === 'EM0028') {
        // 서버에서 체크한 pin 번호 카운트가 5일경우
        state.incorrectPINcount = 5;
      }
      state.incorrectPINcount = payload?.certFailNum ? payload.certFailNum : state.incorrectPINcount + 1;
    },
    getPinSendEmail: () => {},
    getPinSendEmailSuccess: (state, { payload }) => {
      state.pinSendInfo = payload;
    },
    setNoticePush: (state, { payload }) => {
      state.pushYn = payload;
    },
    getMobileToken: () => {},
    getMobileTokenSuccess: (state, { payload }) => {
      state.push.userToken = payload.pushUserToken;
      state.push.pushServer = payload.pushServer;
    },
    getCheckMobileUser: () => {},
    getCheckMobileUserSuccess: (state, { payload }) => {
      state.mobileUserYn = payload;
    },
    addMobilePush: state => {
      state.isSuccessPushAuth = false;
    },
    addMobilePushSuccess: (state, { payload }) => {
      state.isSuccessPushAuth = payload;
    },
    addSkip: () => {},
    addSkipSuccess: (state, { payload }) => {
      state.isCheckPinCode = payload;
    },
  },
});

export const {
  setRequestOtpState,
  initAuthenticateFnmFail,
  getAuthenticateFnm,
  getAuthenticateFnmSuccess,
  setAuthenticateFnmFail,
  getAuthenticateCallPhone,
  getAuthenticateCallPhoneSuccess,
  getAuthenticateCallPhoneFail,
  getAuthenticateExternalMail,
  getAuthenticateExternalMailSuccess,
  getAuthenticateExternalMailFail,
  getAuthenticateAuthNum,
  getAuthenticateAuthNumSuccess,
  setAuthenticateAuthNumFail,
  modifyAuthenticatePassword,
  modifyAuthenticatePasswordSuccess,
  resetIncorrectOTPcount,
  getCheckPinCode,
  getCheckPinCodeSuccess,
  getCheckPinCodeFail,
  getPinSendEmail,
  getPinSendEmailSuccess,
  setNoticePush,
  getCheckMobileUser,
  getCheckMobileUserSuccess,
  getMobileToken,
  getMobileTokenSuccess,
  addMobilePush,
  addMobilePushSuccess,
  addSkip,
  addSkipSuccess,
} = findPasswordSlice.actions;
export default findPasswordSlice.reducer;
